import { css } from "@compiled/react";
import { FormattedMessage } from "react-intl";

import AccountCreation, { Social } from "@/components/signup/account-creation";
import { useCfind6099JiraGoogleOnlySocialProviders } from "@/components/signup/hooks";
import { JiraOverlayTemplate } from "@/components/signup/layouts";
import { useLocalizedHref } from "@/libraries/web-framework";
import { experiments, useExperiment } from "@/utils/experiment";
import { FeatureExposed } from "@/utils/feature-exposed";
import { checkFeatureFlagGate, featureFlags } from "@/utils/feature-flags";
import { useLocation } from "@/utils/location-provider";
import { getWacIntegrationUrl } from "@/utils/urls";

import {
    InputSubmitButton,
    GetStartedHeading,
    GetStartedText,
    Headings
} from "../../../components";

export const LoggedOutJiraFree = () => {
    const socialSignupProviders = useCfind6099JiraGoogleOnlySocialProviders();

    const team26VisualUpdates = checkFeatureFlagGate(
        featureFlags.cfind4831ProductOverlayModalVisualUpdates
    );

    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const editionIntent = searchParams.get("editionIntent");

    const jiraPlusPage = useLocalizedHref(
        `/software/jira/free${
            editionIntent ? `?editionIntent=${editionIntent}` : ""
        }`
    );

    const jiraPlusExperiment = useExperiment(experiments.twcg1444JiraPlusOptIn);

    const getContinueUrl: () => string | undefined = () => {
        if (jiraPlusExperiment.type === "enrolled") {
            jiraPlusExperiment.fireExposure();
            if (jiraPlusExperiment.value) {
                return `${getWacIntegrationUrl()}${jiraPlusPage}`;
            }
        }
    };

    return (
        <FeatureExposed
            experimentKey="jfind-1565-sign-up-flow-overlay"
            group="Test"
        >
            <JiraOverlayTemplate size="sm">
                {team26VisualUpdates ? (
                    <Headings
                        main={<GetStartedText productName="Jira" />}
                        sub={
                            <FormattedMessage
                                id="signupForm.accountCreation.subHeaderText"
                                defaultMessage="It’s free for up to 10 users - no credit card needed."
                            />
                        }
                    />
                ) : (
                    <>
                        <GetStartedHeading productName="Jira" />
                        <p css={subHeaderCss}>
                            <FormattedMessage
                                id="signupForm.accountCreation.subHeaderText"
                                defaultMessage="It’s free for up to 10 users - no credit card needed."
                            />
                        </p>
                    </>
                )}
                <FeatureExposed
                    experimentKey="jfind-1185-signup-button-update"
                    group="Test"
                >
                    <AccountCreation
                        getContinueUrl={getContinueUrl}
                        Input={<InputSubmitButton />}
                        Social={<Social providers={socialSignupProviders} />}
                        Submit={null}
                    />
                </FeatureExposed>
            </JiraOverlayTemplate>
        </FeatureExposed>
    );
};

const subHeaderCss = css({
    margin: "0 0 24px",
    textAlign: "center"
});
